import { useContext, useEffect, useState } from 'react';
import Spinner from '../../UI/Modal/Spinner';
import Inputs from './components/Inputs';
import MyButton from '../../UI/myButton/MyButton';
import GridProvider from './components/GridProvider';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/use-http';
import { TabContext } from '../../../Context/TabContext';
import { urls } from './api/urls';
import toast from 'react-hot-toast';

const initialValues = {
  id: 0,
  idKupca: null,
  ime: '',
  prezime: '',
  kontaktTelefon: '',
  email: '',
  idKorProm: 0,
  napomena: '',
};

const KontaktiFirme = ({ novi, handleNovi, save, handleSave, idKlijenta }) => {
  const { t, i18n } = useTranslation();
  const { sendRequest, data, isLoading } = useHttp('');
  // const { sendRequest: vratiKupce, data: kupciData } = useHttp('');
  const { getData } = useHttp('');
  const [formData, setFormData] = useState(initialValues);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);

  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localFormData = dataLocal?.formData ? dataLocal?.formData : {};

  useEffect(() => {
    if (Object.keys(localFormData).length > 0) {
      setFormData({
        ...formData,
        kontaktTelefon: localFormData.kontaktTelefon,
        email: localFormData.email,
      });
    }
  }, []);

  const handleNoviUnos = () => {
    setFormData(initialValues);
  };

  useEffect(() => {
    if (novi) {
      handleNoviUnos();
      handleNovi(false);
    }
  }, [novi]);

  const fetchData = () => {
    const config = {
      method: 'POST',
      url: urls.GET_KONTAKT,
      data: { id: idKlijenta },
    };
    sendRequest(config);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const tab = {
      type: 69,
      title: 'Lokacije',
      icon: 'fas fa-map-marker-alt',
      formData: formData,
    };
    onTabChange(tab);
  }, [formData]);

  const handleSaveData = async () => {
    const url = formData.id === 0 ? urls.INSERT_KONTAKT : urls.UPDATE_KONTAKT;
    const config = {
      url,
      method: 'POST',
      data: {
        ...formData,
        idKupca: idKlijenta,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const response = await getData(config);

    if (response.id > 0) {
      toast.success(
        formData.id === 0 ? 'Uspešan unos kontakta' : 'Uspešna izmena kontakta',
      );
      fetchData();
      setFormData(initialValues);
    } else {
      toast.error('Greška pri čuvanju podataka');
    }
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  const handleEditData = (item) => {
    setFormData({
      id: item.id,
      idKupca: item.idKupca,
      ime: item.ime,
      prezime: item.prezime,
      kontaktTelefon: item.kontaktTelefon,
      email: item.email,
      napomena: item.napomena,
    });
  };

  const handleOpenDeleteDialog = (id) => {
    setFormData({ ...formData, id: id });
    setOpenDeleteDialog(true);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_KONTAKT,
      data: { id: formData.id },
    };
    const result = await getData(config);

    if (result > 0) {
      fetchData();
      toast.success('Uspešano obrisan podatak');
      setOpenDeleteDialog(false);
      setFormData(initialValues);
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };

  return (
    <div>
      {isLoading && <Spinner />}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Inputs
          formData={formData}
          setFormData={setFormData}
          // korisniciData={kupciData}
        />
        {idKlijenta && (
          <div>
            <MyButton label="Sačuvaj kontakt" onClick={handleSaveData} />
            <MyButton label="Novi kontakt" onClick={handleNoviUnos} />
          </div>
        )}
      </div>

      <GridProvider
        data={data}
        handleOpenDialog={handleOpenDeleteDialog}
        getEditData={handleEditData}
        isLoading={isLoading}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default KontaktiFirme;
